import React, { Component } from "react";
import {
  Form,
  Input,
  DatePicker,
  Select,
  Modal,
  message,
  Checkbox,
  Upload,
  Button,
  Tabs,
  Row,
  Col,
  ColorPicker,
  Tooltip,
  Spin,
  Space,
  Image,
  Drawer,
} from "antd";
import addIcon from "../assets/images/NewDesign/plus-lg.svg";
import dayjs from "dayjs";
import CompanyAutocomplete from "./CompanyAutocomplete";
import { StoreContext } from "../store/RootStore";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import DriversStore from "../store/DriversStore";
import { observer } from "mobx-react";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";

import CompanyStore from "../store/CompanyStore";
import CountryStore from "../store/CountryStore";
import "./AddAccount.css";
import config from "../config";
import DriverAdd from "./DriverAdd";
import VehicleDetailsTabFormFields from "./Plugins/AddVehicle/VehicleDetailsTabFormFields";
import VehicleAccountTabFormFields from "./Plugins/AddVehicle/VehicleAccountTabFormFields";
import VehicleTankTabFormFields from "./Plugins/AddVehicle/VehicleTankTabFormFields";
import VehicleInfoTabFormFields from "./Plugins/AddVehicle/VehicleInfoTabFormFields";
import VehicleInfoAwtlFormFields from "./Plugins/AddVehicle/VehicleInfoAwtlFormFields";
import VehicleInfoDrive7Fields from "./Plugins/AddVehicle/VehicleInfoDrive7Fields";

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

const { TabPane } = Tabs;

class VehicleAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      tabErrors: {},
      formError: false,

      loading: false,
      vehicleId: -1,
      vehiCalSpeed: false,
      companyId: "",
      fuelSensor: false,
      DriverId: false,
      loadSensor: false,
      temperatureSensor: false,
      rfid: false,
      pta: false,
      sfda: false,
      basic: false,
      driverId: "",
      // getpollimie: [],
      timezoneId: Number(config.defaultTimezoneId),
      one: true,
      two: true,
      three: true,

      horizontalrectangle: false,
      verticalcylinder: false,
      horizontalcylinder: false,

      horizontalrectangle2: false,
      verticalcylinder2: false,
      horizontalcylinder2: false,

      horizontalrectangle3: false,
      verticalcylinder3: false,
      horizontalcylinder3: false,

      vehicleType: "",

      school: false,
      loadData: 0,

      colorHex: "",
      formatHex: "hex",

      icon: "",
      headWeight: "",
      imeiError: false,
      openDriverDetailsForm: false,
      tagIdShow: false,

      showtIdField: true,
      redfield: false,

      loadingSpin: false,

      disabledField: false,
      pulseFields: false,
      selectRules: false,
      mdvrFields: false,
    };
    this.driverStore = new DriversStore();
    this.vehicleStore = new VehicleStore();
    this.companyStore = new CompanyStore();

    this.countryStore = new CountryStore();
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setVehicleStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });

      // const pollingData = await this.vehicleStore.getPollingImeiData();

      // await this.setState({ getpollimie: pollingData });

      // await this.setState({ full_imei: pollingData[0].imei });

      // this.formRef.current.setFieldsValue({ full_imei: pollingData[0].imei });

      await this.driverStore.toGetDriverName(
        this.props.getUserData().userCompanyId
      );

      const vehicleData = this.driverStore.getVehicles(
        this.props.getUserData().userCompanyId
      );
    }
    await this.countryStore.getCountry();
    await this.countryStore.getTimeZone();

    await this.vehicleStore.getPollingImeiData();

    await this.vehicleStore.getFuelCaliDetails();

    await this.setState({ loadList: 1 });

    const vehicleId = this.props.vehicleIdForEdit;

    if (vehicleId) {
      await this.filldata(vehicleId);
      this.setState({ vehicleId: vehicleId });
    }
  }

  filldata = async (vehicleId) => {
    await this.setState({ loadingSpin: true });
    const getVehicleDetails = await this.vehicleStore.getVehicleData(vehicleId);

    await this.setState({
      companyId: getVehicleDetails.companyId,
      vehicleId: getVehicleDetails.vehicleId,
    });
    const singleData = await this.companyStore.getCompanyDataById(
      getVehicleDetails.companyId
    );
    await this.setState({ companyLable: singleData });

    await this.driverStore.toGetDriverName(getVehicleDetails.companyId);

    await this.vehicleStore.getVehicleRules(getVehicleDetails.companyId);

    // const pollingData = await this.vehicleStore.getPollingImeiData();
    // await this.setState({ getpollimie: pollingData });

    await this.formRef.current.setFieldsValue({
      fid1: getVehicleDetails.Fid1,
      fid2: getVehicleDetails.Fid2,
      fid3: getVehicleDetails.Fid3,

      installationspace1: getVehicleDetails.InstallationSpace1,
      installationspace2: getVehicleDetails.InstallationSpace2,
      installationspace3: getVehicleDetails.InstallationSpace3,
      InstallationType: getVehicleDetails.InstallationType,
      nofueltank: getVehicleDetails.No_FuelTank,

      Sensor1: getVehicleDetails.Sensor1,
      Sensor2: getVehicleDetails.Sensor2,
      Sensor3: getVehicleDetails.Sensor3,
      addOn: getVehicleDetails.addOn,

      batteryExpire: getVehicleDetails.batteryExpire,
      branch: getVehicleDetails.branch,
      capacity: getVehicleDetails.capacity,
      ColorCode: getVehicleDetails.colorCode,
      comment: getVehicleDetails.comment,
      companyId: singleData,

      department: getVehicleDetails.department,
      deviceGroupId: getVehicleDetails.deviceGroupId,
      deviceId: getVehicleDetails.deviceId
        ? Number(getVehicleDetails.deviceId)
        : null,
      // deviceName: getVehicleDetails.deviceName,
      diffOdo: getVehicleDetails.diffOdo,
      DigInpt1: getVehicleDetails.digital_Input1,
      DigInpt2: getVehicleDetails.digital_Input2,
      DigInpt3: getVehicleDetails.digital_Input3,
      DigInpt4: getVehicleDetails.digital_Input4,
      AngInpt1: getVehicleDetails.analog_Input1,
      AngInpt2: getVehicleDetails.analog_Input2,
      AngInpt3: getVehicleDetails.analog_Input3,
      AngInpt4: getVehicleDetails.analog_Input4,

      // digital_Input4: parseInt(getVehicleDetails.digital_Input4),
      distance: getVehicleDetails.distance,
      dname: getVehicleDetails.dname,
      downPayment: getVehicleDetails.downPayment,
      // driverId: getVehicleDetails.dname,
      driverId: getVehicleDetails.driverId
        ? Number(getVehicleDetails.driverId)
        : null,

      emiDueDate: getVehicleDetails?.emiDueDate
        ? dayjs(getVehicleDetails.emiDueDate)
        : null,
      emptyWeight: getVehicleDetails.emptyWeight,

      expiryDate: getVehicleDetails?.expiryDate
        ? dayjs(getVehicleDetails?.expiryDate)
        : null,
      fuelConsumption: getVehicleDetails.fuelConsumption,
      minimumFineAmount: getVehicleDetails.minimumFineAmount,
      finePerMinute: getVehicleDetails.finePerMinute,

      fuelId1: getVehicleDetails.fuelId1,
      fuelId2: getVehicleDetails.fuelId2,
      fuel: getVehicleDetails.fuelType,
      full_imei: getVehicleDetails.full_imei,
      mdvrfull_imei: getVehicleDetails.mdvrfull_imei,
      headWeight: getVehicleDetails.headWeight,

      highLimit1: getVehicleDetails.highLimit1,
      highLimit2: getVehicleDetails.highLimit2,
      highLimit3: getVehicleDetails.highLimit3,

      hourMeterReading: getVehicleDetails.hourMeterReading,
      hourMeterReading2: getVehicleDetails.hourMeterReading2,

      idleLimit: getVehicleDetails.idleLimit,
      installDate: getVehicleDetails?.installDate
        ? dayjs(getVehicleDetails?.installDate)
        : null,
      installedLocation: getVehicleDetails.installedLocation,
      installer: getVehicleDetails.installer,
      insuranceRenewal: getVehicleDetails?.insuranceRenewal
        ? dayjs(getVehicleDetails?.insuranceRenewal)
        : null,

      isCanbus: getVehicleDetails.isCanbus ? 1 : 0,
      isDelivery: getVehicleDetails.isDelivery ? 1 : 0,
      lastBatteryDate: getVehicleDetails?.lastBatteryDate
        ? dayjs(getVehicleDetails?.lastBatteryDate)
        : null,
      lastDistanceOil: getVehicleDetails.lastDistanceOil,
      lastDistanceService: getVehicleDetails.lastDistanceService,
      lastDistanceTire: getVehicleDetails.lastDistanceTire,
      lastExpiryDate: getVehicleDetails?.lastExpiryDate
        ? dayjs(getVehicleDetails?.lastExpiryDate)
        : null,
      oilchangeKm: getVehicleDetails.lastOil,

      lastoilchange: getVehicleDetails?.lastOilDate
        ? dayjs(getVehicleDetails?.lastOilDate)
        : null,
      lastservicedone: getVehicleDetails?.lastServiceDate
        ? dayjs(getVehicleDetails?.lastServiceDate)
        : null,
      tirechangeKm: getVehicleDetails.lastTire,
      lasttirechange: getVehicleDetails?.lastTireDate
        ? dayjs(getVehicleDetails?.lastTireDate)
        : null,
      machineservicehours: getVehicleDetails.machineServiceHours,
      manufactureYear: getVehicleDetails.manufactureYear,
      maxHoursPerDay: getVehicleDetails.maxHoursPerDay,

      maxVolt: getVehicleDetails.maxVolt,
      minVolt: getVehicleDetails.minVolt,
      mobileno: getVehicleDetails.mobileno,
      vehicleModel: getVehicleDetails.model,
      monthlyEmi: getVehicleDetails.monthlyEmi,

      mulkiyaRenewal: getVehicleDetails?.mulkiyaRenewal
        ? dayjs(getVehicleDetails?.mulkiyaRenewal)
        : null,
      noOfEmi: getVehicleDetails.noOfEmi,
      odometerReading: getVehicleDetails.odometerReading,
      ownership: getVehicleDetails.ownership,
      password: getVehicleDetails.password,
      paymentType: getVehicleDetails.paymentType,
      permitExpiryDate: getVehicleDetails?.permitExpiryDate
        ? dayjs(getVehicleDetails?.permitExpiryDate)
        : null,
      nationalPermitExpiryDate: getVehicleDetails?.nationalPermitExpiryDate
        ? dayjs(getVehicleDetails?.nationalPermitExpiryDate)
        : null,
      pollutionExpiryDate: getVehicleDetails?.pollutionExpiryDate
        ? dayjs(getVehicleDetails?.pollutionExpiryDate)
        : null,
      plateType: parseInt(getVehicleDetails.plateType),
      plateno: getVehicleDetails.vehicleNo,
      region: getVehicleDetails.region,
      regularRunningHours: getVehicleDetails.regularRunningHours,
      renewalPrice: getVehicleDetails.renewalPrice,
      seater: getVehicleDetails.seater,
      sequenceNo: getVehicleDetails.sequenceNo,
      serviceexpireKm: getVehicleDetails.serviceexpire,
      vehiclesimno: getVehicleDetails.simNo,
      speedlimit: getVehicleDetails.speedLimit,

      tId: getVehicleDetails.tId,
      tankdiameter1: getVehicleDetails.tankDiameter,
      tankdiameter2: getVehicleDetails.tankDiameter2,
      tankdiameter3: getVehicleDetails.tankDiameter3,
      tankheight1: getVehicleDetails.tankHeight,
      tankheight2: getVehicleDetails.tankHeight2,

      tankheight3: getVehicleDetails.tankHeight3,
      tanklength1: getVehicleDetails.tankLength,
      tanklength2: getVehicleDetails.tankLength2,
      tanklength3: getVehicleDetails.tankLength3,
      tankshape1: getVehicleDetails.tankShape,
      tankshape2: getVehicleDetails.tankShape2,
      tankshape3: getVehicleDetails.tankShape3,

      tankvolume: getVehicleDetails.tankVolume,
      tankwidth1: getVehicleDetails.tankWidth,
      tankwidth2: getVehicleDetails.tankWidth2,
      tankwidth3: getVehicleDetails.tankWidth3,
      tempId1: getVehicleDetails.tempId1,
      tempId2: getVehicleDetails.tempId2,
      tempId3: getVehicleDetails.tempId3,
      timezoneId: Number(getVehicleDetails.timezoneId),
      totalVehicleCost: getVehicleDetails.totalVehicleCost,

      // fuel: getVehicleDetails.type,
      username: getVehicleDetails.username,
      vehicleBrand: getVehicleDetails.vehicleBrand,
      vehicleId: getVehicleDetails.vehicleNo,
      vehicleName: getVehicleDetails.vehicleName,
      vehicleNoArabic: getVehicleDetails.vehicleNoArabic,

      vehiclePurchaseDate: getVehicleDetails.vehiclePurchaseDate
        ? dayjs(getVehicleDetails?.vehiclePurchaseDate)
        : null,
      vehicleType: getVehicleDetails.vehicleType,
      vehicleTypeNew: getVehicleDetails.vehicleTypeNew,
      weightFactor: getVehicleDetails.weightFactor,
      pollingimei: getVehicleDetails.pollingimei,
      renewedAt: getVehicleDetails.renewedAt,
      mobileno: getVehicleDetails.mobileno,
      attendantName: getVehicleDetails.attendantName,
      icon: getVehicleDetails.icon,
      rpm: getVehicleDetails.rpm,
      movingRPM: getVehicleDetails.movingRPM,
      idelRPM: getVehicleDetails.idelRPM,

      UDID: getVehicleDetails.UDID,
      UDID2: getVehicleDetails.UDID2,
      seatCapacity: getVehicleDetails.seatCapacity,
      noOfBaggage: getVehicleDetails.noOfBaggage,
      harshAcce: getVehicleDetails.harshAcce,
      harshBrack: getVehicleDetails.harshBrack,
      exIdeling: getVehicleDetails.exIdeling,
      speeding: getVehicleDetails.speeding,
      rpmExcess: getVehicleDetails.rpmExcess,
      inputdigital: getVehicleDetails.inputdigital,
      rule: getVehicleDetails.ruleId,
      speedmileage: getVehicleDetails.speedmileage,
      mileage: getVehicleDetails.mileage,
      pulseCount: getVehicleDetails.pulseCount,
      speedConstant: getVehicleDetails.speedConstant,

      MDVR: getVehicleDetails.MDVR,
      cmsvssWebHost: getVehicleDetails.cmsvssWebHost,
      cmsvssWebPort: getVehicleDetails.cmsvssWebPort,
      cmsvssLoginServerPort: getVehicleDetails.cmsvssLoginServerPort,
      cmsvssPlaybachPort: getVehicleDetails.cmsvssPlaybachPort,
      cmsvssUserName: getVehicleDetails.cmsvssUserName,
      cmsvssPassword: getVehicleDetails.cmsvssUserName,

      fuelConsumption: getVehicleDetails.fuelConsumption,
      fuelCalibrationId: getVehicleDetails.fuelCalibrationId,
      chassisNo: getVehicleDetails.chassisNo,
      technicianName: getVehicleDetails.technicianName,
      remark: getVehicleDetails.remark,
      companyLable: "",
    });
    this.setState({ icon: getVehicleDetails.icon });
    if (getVehicleDetails.No_FuelTank == 1) {
      this.setState({ one: true });
      this.setState({ two: false });
      this.setState({ three: false });
    } else if (getVehicleDetails.No_FuelTank == 2) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: false });
    } else if (getVehicleDetails.No_FuelTank == 3) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: true });
    }

    if (getVehicleDetails.tankShape == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle: true });
    } else if (getVehicleDetails.tankShape == "Vertical Cylinder") {
      this.setState({ verticalcylinder: true });
    } else if (getVehicleDetails.tankShape == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder: true });
    }

    if (getVehicleDetails.tankShape2 == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle2: true });
    } else if (getVehicleDetails.tankShape2 == "Vertical Cylinder") {
      this.setState({ verticalcylinder2: true });
    } else if (getVehicleDetails.tankShape2 == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder2: true });
    }

    if (getVehicleDetails.tankShape3 == "Horizontal Rectangle") {
      this.setState({ horizontalrectangle3: true });
    } else if (getVehicleDetails.tankShape3 == "Vertical Cylinder") {
      this.setState({ verticalcylinder3: true });
    } else if (getVehicleDetails.tankShape3 == "Horizontal Cylinder") {
      this.setState({ horizontalcylinder3: true });
    }

    const addonStr = getVehicleDetails.addOn;
    console.log(getVehicleDetails.addOn);
    if (getVehicleDetails.addOn) {
      const addonArray = addonStr?.split(",");

      addonArray[0] === "1" && this.setState({ fuelSensor: true });
      addonArray[2] === "3" && this.setState({ DriverId: true });
      addonArray[3] === "4" && this.setState({ rfid: true });
      addonArray[1] === "2" && this.setState({ temperatureSensor: true });
      // addonArray[4] === "5" && this.setState({ rfid: true });
    }

    if (getVehicleDetails.vehicleType === 3) {
      this.setState({ school: true });
    }

    if (getVehicleDetails.deviceId === 6) {
      this.setState({ mdvrFields: true });
    }

    if (getVehicleDetails.speedmileage === 2) {
      this.setState({ pulseFields: true });
    }
    if (
      (this.props.getUserData().isadmin === 1 ||
        this.props.getUserData().isadmin === 0) &&
      this.props.vehicleIdForEdit
    ) {
      this.setState({ disabledField: true });
    }

    this.setState({ loadData: 1, loadingSpin: false });
  };

  validateNumberAndDecimal = (value, field) => {
    const value1 = value.replace(/[^0-9.,]+/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  handleSelectAllRules = async (e) => {
    var arr = [];
    this.setState({ selectRules: e.target.checked });

    if (e.target.checked) {
      const data = await this.vehicleStore?.vehicleRules.map((option) =>
        arr.push(option.ruleId)
      );

      this.formRef.current.setFieldsValue({ rule: arr });
    } else {
      arr = [];
      this.formRef.current.setFieldsValue({ rule: arr });
    }
  };

  closeDriverModal = () => {
    this.setState({ openDriverDetailsForm: false });
  };

  responseMsg = async (response) => {
    const DriverName = await this.driverStore.toGetDriverName(
      this.state.companyId
    );

    if (response.success == "S") {
      message.success(response.message);
      await this.driverStore.toGetDriverName(this.state.companyId);
      await this.formRef.current.setFieldsValue({
        driverId: Number(response?.data.driverId),
        // driverId:response.data.name
      });

      await this.setState({ openDriverDetailsForm: false });
      // await this.formRef.current?.resetFields();
    } else if (response.success === "F5000") {
      response.errors.map((value) => {
        message.error(this.context.translate(value["username"]));
        // console.log(this.context.translate(value["driver"]),value["driver"])
      });
    }

    this.setState({ loadData: 1 });
    this.setState({ loading: false });

    const companyData = await this.companyStore.getCompanyDataById(
      this.state.companyId
    );

    await this.setState({ loadData: 1 });
  };

  selectDriver = async (value) => {
    await this.setState({ driverId: value });
    this.formRef.current.setFieldsValue({ driverId: value });
  };

  showPulseFields = (val) => {
    // console.log(val)
    if (val == "Pulse") {
      this.setState({ pulseFields: true });
    } else {
      this.setState({ pulseFields: false });
    }
  };

  onVehicleDetailsSubmit = async (values) => {
    this.setState({ loading: true });
    console.log(values);

    const vehicle = {
      ...values,
      tokenId: "",
      companyId: this.state.companyId,
      vehicleType: this.state.vehicleType,
      vehicleId: this.state.vehicleId,
      userId: 1,
      ColorCode: this.state.colorHex,
      isCanbus: values?.isCanbus ? 1 : 0,
      isDelivery: values?.isDelivery ? 1 : 0,
      installDate: values?.installDate
        ? values?.installDate?.format(dateFormat)
        : null,
      expiryDate: values?.expiryDate
        ? values?.expiryDate?.format(dateFormat)
        : null,
      mulkiyaRenewal: values?.mulkiyaRenewal
        ? values?.mulkiyaRenewal?.format(dateFormat)
        : null,
      insuranceRenewal: values?.insuranceRenewal
        ? values?.insuranceRenewal?.format(dateFormat)
        : null,
      lastservicedone: values?.lastservicedone
        ? values?.lastservicedone?.format(dateFormat)
        : null,
      lastoilchange: values?.lastoilchange
        ? values?.lastoilchange?.format(dateFormat)
        : null,
      lasttirechange: values?.lasttirechange
        ? values?.lasttirechange?.format(dateFormat)
        : null,
      lastBatteryDate: values?.lastBatteryDate
        ? values?.lastBatteryDate?.format(dateFormat)
        : null,
      emiDueDate: values?.emiDueDate
        ? values?.emiDueDate?.format(dateFormat)
        : null,
      vehiclePurchaseDate: values?.vehiclePurchaseDate
        ? values?.vehiclePurchaseDate?.format(dateFormat)
        : null,
      permitExpiryDate: values?.permitExpiryDate
        ? values?.permitExpiryDate?.format(dateFormat)
        : null,
      nationalPermitExpiryDate: values?.nationalPermitExpiryDate
        ? values?.nationalPermitExpiryDate?.format(dateFormat)
        : null,
      pollutionExpiryDate: values?.pollutionExpiryDate
        ? values?.pollutionExpiryDate?.format(dateFormat)
        : null,

      addOn: [
        this.state.fuelSensor ? "1" : "0",
        this.state.temperatureSensor ? "2" : "0",
        this.state.DriverId ? "3" : "0",
        this.state.rfid ? "4" : "0",
      ],
      icon: this.state.icon,
    };

    const data = { tokenId: "", vehicle: vehicle };

    const resp = await this.vehicleStore.addData(data);

    await this.props.response(resp);
    if (
      this.context.translate(resp.data?.errors[0]?.full_imei) ===
      "IMEI NO. Already Exist for Asset"
    ) {
      // this.setState({ imeiError:"IMEI NO. Already Exist for Asset"});
      this.setState({
        imeiError: (
          <div style={{ marginTop: 5, color: "red", fontSize: 12 }}>
            IMEI NO. Already Exist for Asset
          </div>
        ),
      });
    }
    this.setState({ loading: false });
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.vehicleIdForEdit) {
      this.context.viewStateStore.setVehicleStates({ companyId: comp.value });
    }
    await this.formRef.current.setFieldsValue({
      companyId: this.state.companyId,
    });

    await this.setState({
      companyLable: { label: comp.label, value: comp.value },
    });

    // const pollingData = await this.vehicleStore.getPollingImeiData();

    // console.log(pollingData[0],"pollingData")

    // await this.setState({ getpollimie: pollingData });

    // await this.setState({ full_imei: pollingData[0].imei });

    // this.formRef.current.setFieldsValue({ full_imei: pollingData[0].imei });

    await this.driverStore.toGetDriverName(comp.value);

    const vehicleData = await this.driverStore.getVehicles(comp.value);

    const ruleData = await this.vehicleStore.getVehicleRules(comp.value);

    await this.handleSearch();
  }

  async handleSearch() {
    await this.vehicleStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
      userId: this.props.getUserData().userId,
      usercompanyId: this.props.getUserData().userCompanyId,
    });
    await this.setState({ loadList: 1 });
  }

  addOn = (value) => {
    for (let i = 0; i < value.length; i++) {
      if (value[i] === 1) {
        this.setState({ fuelSensor: true });
      } else if (value[i] === 3) {
        this.setState({ DriverId: true });
      } else if (value[i] === 2) {
        this.setState({ temperatureSensor: true });
      } else if (value[i] === 4) {
        this.setState({ rfid: true });
      } else {
        this.setState({ fuelSensor: false });
        this.setState({ DriverId: false });

        this.setState({ temperatureSensor: false });
        this.setState({ rfid: false });
      }
    }
  };

  noOfFuelTanks = (value) => {
    if (value === 1) {
      this.setState({ one: true });
      this.setState({ two: false });
      this.setState({ three: false });
    } else if (value === 2) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: false });
    } else if (value === 3) {
      this.setState({ one: true });
      this.setState({ two: true });
      this.setState({ three: true });
    } else {
      this.setState({ one: false });
      this.setState({ two: false });
      this.setState({ three: false });
    }
  };
  tankShape1 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle: true });
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalcylinder: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder: true });
      this.setState({ horizontalrectangle: false });
      this.setState({ horizontalcylinder: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder: true });
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalrectangle: false });
    } else {
      this.setState({ verticalcylinder: false });
      this.setState({ horizontalrectangle: false });
      this.setState({ horizontalcylinder: false });
    }
  };

  tankShape2 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle2: true });
      this.setState({ horizontalcylinder2: false });
      this.setState({ verticalcylinder2: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder2: true });
      this.setState({ horizontalrectangle2: false });
      this.setState({ horizontalcylinder2: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder2: true });
      this.setState({ verticalcylinder2: false });
      this.setState({ horizontalrectangle2: false });
    } else {
      this.setState({ verticalcylinder2: false });
      this.setState({ horizontalrectangle2: false });
      this.setState({ horizontalcylinder2: false });
    }
  };

  tankShape3 = (value) => {
    if (value === "Horizontal Rectangle") {
      this.setState({ horizontalrectangle3: true });
      this.setState({ horizontalcylinder3: false });
      this.setState({ verticalcylinder3: false });
    } else if (value === "Vertical Cylinder") {
      this.setState({ verticalcylinder3: true });
      this.setState({ horizontalrectangle3: false });
      this.setState({ horizontalcylinder3: false });
    } else if (value === "Horizontal Cylinder") {
      this.setState({ horizontalcylinder3: true });
      this.setState({ verticalcylinder3: false });
      this.setState({ horizontalrectangle3: false });
    } else {
      this.setState({ verticalcylinder3: false });
      this.setState({ horizontalrectangle3: false });
      this.setState({ horizontalcylinder3: false });
    }
  };

  handleVTypeChange = async (value, option) => {
    await this.setState({ vehicleType: option.data });
    await this.formRef.current.setFieldsValue({ vehicleTypeNew: option.value });
  };
  onSelectSchool = (value) => {
    if (value === "SchoolBus") {
      this.setState({ school: true });
    } else {
      this.setState({ school: false });
    }
  };

  validateFieldsValue = (value, field) => {
    // Check if value contains only numbers
    // const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9.]*/g, "");

    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  validateYearField = (value, field) => {
    console.log("value", value);
    console.log("field", value);
    console.log("error", this.state.imeiError);
    const value1 = value.replace(/[^0-9+]*/g, "");
    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }

    if (field === "full_imei" && this.state.imeiError) {
      this.setState({ imeiError: null });
    }
  };

  getTypeByCategory = async (categoryId) => {
    const data = await this.vehicleStore.getTypeByCategory(categoryId);

    await this.setState({ loadData: 1 });
  };

  getWeightsUsingTid = async (tId) => {
    const data = await this.vehicleStore.getWeightBytId(tId);

    await this.formRef.current.setFieldsValue({
      emptyWeight: data.trailerEmptyWeight,
    });

    const total = parseFloat(this.state.headWeight) + data.trailerEmptyWeight;

    await this.setState({ loadData: 1 });
  };

  warning = () => {
    Modal.warning({
      // title: "Alert",
      title: this.context.translate("_FLEET_ALERT_"),
      // content: "Please select installation type as PTA to enable load Sensor",
      content: this.context.translate("_INSTALLATION_TYPE_MESSAGE_"),
    });
  };

  handleChangeHex = (color) => {
    const colorHex = typeof color === "string" ? color : color.toHexString();
    this.setState({ colorHex });
  };

  handleFormatChangeHex = (formatHex) => {
    this.setState({ formatHex });
  };
  handleFormError = (err) => {
    const { errorFields } = err;

    const tabErrors = {};

    errorFields.forEach(({ name }) => {
      const [fieldName] = name;
      const tabFieldMappings = {
        companyId: 1,
        plateno: 1,
        vehicleTypeNew: 1,
        timezoneId: 1,
        installDate: 1,
        renewalPrice: 1,
        pollingimei: 1,
        vehiclesimno: 1,
        full_imei: 1,
        vehicleNoArabic: 1,
        // second tab

        // third tab
        installer: 3,
        installedLocation: 3,
      };
      const tab = tabFieldMappings[fieldName];
      console.warn(tab);
      if (tab) {
        tabErrors[tab] = true;
      }
    });

    this.setState({ tabErrors }); // Update the state with tabErrors
  };

  handleNextClick = async () => {
    const form = this.formRef.current;

    if (form) {
      try {
        if (this.state.activeTab === "1") {
          // Validate only the fields in the 'User Information' tab
          await form.validateFields([
            "companyId",
            "plateno",
            "vehicleTypeNew",
            "timezoneId",
            "installDate",
            "renewalPrice",
            "pollingimei",
            "vehiclesimno",
            "full_imei",
            "vehicleNoArabic",
          ]);
        } else {
          // Validate all fields in other tabs
          await form.validateFields();
        }

        const { activeTab } = this.state;
        const nextTab = String(Number(activeTab) + 1);
        this.setState({ activeTab: nextTab });
        if (this.state.imeiError) {
          message.error("IMEI Error: Please correct it before proceeding.");
          return;
        }
      } catch (err) {
        console.error("Form Validation Error:", err);
        message.error(
          this.context.translate("_FLEET_GROUP_GROUPDETAIL_ERRORMSG_")
          // "Please fill correct data in the fields that are marked red."
        );

        this.setState({ formError: true });
      }
    }
  };
  handleTabChange = (key) => {
    this.setState({
      activeTab: key,
      formError: false, // Reset formError when switching tabs
    });
  };

  handleBackClick = () => {
    const { activeTab } = this.state;
    const previousTab = String(Number(activeTab) - 1);

    this.setState({ activeTab: previousTab });
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    if (fileinfo?.success == "S") {
      // console.log(fileinfo.data)

      await this.setState({ icon: fileinfo.data });
    }
    fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
    this.vehicleStore.setLogoFromDb(fileUp.fileList);

    this.setState({ update: 1 });
  };

  validatePhoneNumber = (value, field) => {
    // Check if value contains only numbers
    // const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9+]*/g, "");

    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };

  handleDeviceFields = (val) => {
    console.log(val);
    if (val == 6) {
      this.setState({ mdvrFields: true });
    } else {
      this.setState({ mdvrFields: false });
    }
  };
  validateFieldsValue = (value, field) => {
    // Check if value contains only numbers
    // const isValid = /^[0-9]+$/.test(value);
    const value1 = value.replace(/[^0-9.]*/g, "");
    console.log(value1);
    if (value1) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  handleCheckboxChange = (checked, field) => {
    // console.log(checked, field)
    this.setState({ [field]: checked });
  };

  handleCheckboxValues = (checked, field) => {
    // console.log(checked, field)
    this.setState({ [field]: checked });
  };

  warning = () => {
    Modal.warning({
      // title: "Alert",
      title: this.context.translate("_FLEET_ALERT_"),
      // content: "Please select installation type as PTA to enable load Sensor",
      content: this.context.translate("_INSTALLATION_TYPE_MESSAGE_"),
    });
  };

  installationType = (value) => {
    if (value === "PTA") {
      this.setState({ pta: true, loadSensor: true });
      this.setState({ sfda: false });
      this.setState({ basic: false });
      this.setState({ showtIdField: true });
    } else if (value === "SFDA") {
      this.setState({ sfda: true });
      this.setState({ pta: false, loadSensor: true });
      this.setState({ basic: false });
      this.setState({ showtIdField: true });
    } else if (value === "Basic") {
      this.setState({ pta: false });
      this.setState({ sfda: false });
      this.setState({ loadSensor: false });
      this.setState({ basic: true });
      this.setState({ showtIdField: true });
    }
  };

  handleLoadSensorCheckbox = (newState) => {
    // console.log(newState)
    this.setState(newState);
  };
  showTabTitle = () => {
    const { activeTab } = this.state;

    if (activeTab === "1") {
      return this.context.translate("_FLEET_VEHICALDETAIL_TITLE_");
    } else if (activeTab === "2") {
      return this.context.translate("_FLEET_VEHICLE_USERDETAIL_TITLE_");
    } else if (activeTab === "3") {
      return this.context.translate("_VEHICLE_INFO_");
    } else if (activeTab === "4") {
      return this.context.translate("_TANK_DETAILS_");
    }
  };

  showTabDesc = () => {
    const { activeTab } = this.state;
    if (activeTab === "1") {
      return this.context.translate("_VEHICLE_ADD_DESC_");
    } else if (activeTab === "2") {
      return this.context.translate("_VEHICLE_DETAILS_ADD_DESC_");
    } else if (activeTab === "3") {
      return this.context.translate("_VEHICLE_INFO_DESC_");
    } else if (activeTab === "4") {
      return this.context.translate("_TANK_DETAILS_DESC_");
    }
  };
  render() {
    const { colorHex, formatHex } = this.state;

    return (
      <>
        <div style={{ padding: 0, height: "100%" }}>
          <div style={{ height: "100%" }}>
            <Spin
              spinning={this.state.loadingSpin}
              wrapperClassName="spinClass"
              fullscreen
            >
              <Form
                ref={this.formRef}
                labelCol={{
                  span: 20,
                }}
                layout="vertical"
                onFinish={this.onVehicleDetailsSubmit}
                onFinishFailed={this.handleFormError}
                className="accountFormClass"
                name="nest-message"
              >
                <div style={{ height: "100%" }}>
                  <div
                    style={{
                      background: "#07163D",
                      padding: "15px",
                      height: "10%",
                    }}
                  >
                    <h3 className="tab-title">{this.showTabTitle()}</h3>
                    <p className="tab-description">{this.showTabDesc()}</p>
                  </div>
                  <Tabs
                    className="accountTabs"
                    style={{ height: "90%" }}
                    activeKey={this.state.activeTab}
                    onChange={this.handleTabChange}
                  >
                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["1"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "1"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_ASSET_DETAILS_")}
                          </Button>
                        </span>
                      }
                      key="1"
                    >
                      <Row
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <Col span={12} className="formColumnClass">
                          {(this.props.getUserData().isadmin === -1 ||
                            this.props.getUserData().isadmin === 3) && (
                            <Form.Item
                              className="uploadCompany"
                              name="companyId"
                              // label={this.context.translate("_ACCOUNT_")}
                              label={
                                <span>
                                  {this.context.translate("_ACCOUNT_")}{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </span>
                              }
                              required={false}
                              rules={[
                                {
                                  required: true,
                                  message: `${this.context.translate(
                                    "_ACCOUNT_"
                                  )} ${this.context.translate(
                                    "_IS_REQUIRED_"
                                  )}`,
                                },
                              ]}
                            >
                              <CompanyAutocomplete
                                onChange={(value) => {
                                  this.handleChange(value);
                                }}
                                companyId={this.state.companyId}
                                style={{ width: "100%" }}
                              />
                            </Form.Item>
                          )}

                          {this.props.getUserData().isadmin !== 1 && (
                            <Form.Item
                              className="uploadCompany"
                              name="pollingimei"
                              label={this.context.translate("_POLLING_IMEI_")}
                            >
                              <Select
                                onSelect={(val, record) =>
                                  this.formRef.current.setFieldsValue({
                                    full_imei: record.children,
                                  })
                                }
                              >
                                {this.vehicleStore?.getpollimie.map((val) => {
                                  return (
                                    <Option key={val.pollId} value={val.pollId}>
                                      {val.imei}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          )}
                          <div
                            style={{
                              display: "flex",
                              // justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <Form.Item
                              name="isCanbus"
                              // className="formCheckboxCss"
                              label=" "
                              valuePropName="checked"
                              // style={{ marginRight: '5px' }}
                            >
                              <Checkbox>
                                {this.context.translate("_CANBUS_")}
                              </Checkbox>
                            </Form.Item>
                            <Form.Item
                              name="isDelivery"
                              label=" "
                              valuePropName="checked"
                              style={{ marginInlineStart: "15px" }}
                            >
                              <Checkbox>
                                {this.context.translate("_DELIVERY_")}
                              </Checkbox>
                            </Form.Item>
                          </div>
                          <Form.Item
                            className="uploadCompany"
                            name="fuelConsumption"
                            // label="Vehicle Mileage"
                            label={this.context.translate("_VEHICLE_MILAGE_")}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "fuelConsumption"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="comment"
                            // label="Comment"
                            label={this.context.translate(
                              "_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"
                            )}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="plateno"
                            // label={this.context.translate("_PLATE_NO_")}
                            label={
                              <span>
                                {this.context.translate("_PLATE_NO_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_PLATE_NO_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Input disabled={this.state.disabledField} />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="vehicleName"
                            // label="Asset Name/Alias"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_VEHICLENAME_"
                            )}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="vehicleNoArabic"
                            // label="Asset Name/Alias"
                            // label={this.context.translate("ARABIC_VEHICLE_NO_")}
                            label={
                              <span>
                                {this.context.translate("ARABIC_VEHICLE_NO_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "ARABIC_VEHICLE_NO_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="vehicleTypeNew"
                            // label={this.context.translate("_VEHICLE_TYPE_")}
                            label={
                              <span>
                                {this.context.translate("_VEHICLE_TYPE_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_VEHICLE_TYPE_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Select
                              onChange={(value) =>
                                this.onSelectSchool(value.value)
                              }
                              onSelect={this.handleVTypeChange}
                              labelInValue
                              options={[
                                {
                                  value: "Truck",
                                  // label: "Truck",
                                  label: this.context.translate("_TRUCK_"),
                                  data: "1",
                                },
                                {
                                  value: "Car",
                                  // label: "Car",
                                  label: this.context.translate("_car_"),
                                  data: "2",
                                },
                                {
                                  value: "SchoolBus",
                                  // label: "SchoolBus",
                                  label: this.context.translate("_SCHOOL_BUS_"),
                                  data: "3",
                                },
                                {
                                  value: "PickUp",
                                  // label: "PickUp",
                                  label: this.context.translate("_PICKUP_"),
                                  data: "4",
                                },
                                {
                                  value: "2Ton PickUp",
                                  // label: "2Ton PickUp",
                                  label:
                                    this.context.translate("_2TON_PICKUP_"),
                                  data: "29",
                                },
                                {
                                  value: "3Ton PickUp",
                                  // label: "3Ton PickUp",
                                  label:
                                    this.context.translate("_3TON_PICKUP_"),
                                  data: "5",
                                },
                                {
                                  value: "5Ton PickUp",
                                  // label: "5Ton PickUp",
                                  label:
                                    this.context.translate("_5TON_PICKUP_"),
                                  data: "6",
                                },
                                {
                                  value: "10Ton PickUp",
                                  // label: "10Ton PickUp",
                                  label:
                                    this.context.translate("_10TON_PICKUP_"),
                                  data: "7",
                                },
                                {
                                  value: "Crane",
                                  // label: "Crane",
                                  label: this.context.translate("_CRANE_"),
                                  data: "8",
                                },
                                {
                                  value: "JCB",
                                  // label: "JCB",
                                  label: this.context.translate("_JCB_"),
                                  data: "9",
                                },
                                {
                                  value: "Van",
                                  // label: "Van",
                                  label: this.context.translate("_VAN_"),
                                  data: "10",
                                },
                                {
                                  value: "Hiace",
                                  // label: "Hiace",
                                  label: this.context.translate("_HIACE_"),
                                  data: "11",
                                },
                                {
                                  value: "Urvan",
                                  // label: "Urvan",
                                  label: this.context.translate("_URVAN_"),
                                  data: "12",
                                },
                                {
                                  value: "Tanker",
                                  // label: "Tanker",
                                  label: this.context.translate("_TANKER_"),
                                  data: "13",
                                },
                                {
                                  value: "Bulldozer",
                                  // label: "Bulldozer",
                                  label: this.context.translate("_BULLDOZER_"),
                                  data: "14",
                                },
                                {
                                  value: "Dumper",
                                  // label: "Dumper",
                                  label: this.context.translate("_DUMPER_"),
                                  data: "15",
                                },
                                {
                                  value: "Reefer",
                                  // label: "Reefer",
                                  label: this.context.translate("_REEFER_"),
                                  data: "16",
                                },
                                {
                                  value: "Shovel",
                                  // label: "Shovel",
                                  label: this.context.translate("_SHOVEL_"),
                                  data: "17",
                                },
                                {
                                  value: "Excavator",
                                  // label: "Excavator",
                                  label: this.context.translate("_EXCAVATOR_"),
                                  data: "18",
                                },
                                {
                                  value: "Trailer",
                                  label: this.context.translate("_TAILER_"),
                                  // label: "Trailer",
                                  data: "19",
                                },
                                {
                                  value: "Forklif",
                                  // label: "Forklif",
                                  label: this.context.translate("_FORKLIF_"),
                                  data: "20",
                                },
                                {
                                  value: "Bobcat",
                                  // label: "Bobcat",
                                  label: this.context.translate("_BOBCAT_"),
                                  data: "21",
                                },
                                {
                                  value: "Roller",
                                  // label: "Roller",
                                  label: this.context.translate("_ROLLER_"),
                                  data: "22",
                                },
                                {
                                  value: "Canter",
                                  // label: "Canter",
                                  label: this.context.translate("_CANTER_"),
                                  data: "23",
                                },
                                {
                                  value: "Mini Bus",
                                  // label: "Mini Bus",
                                  label: this.context.translate("_MINIBUS_"),
                                  data: "24",
                                },
                                {
                                  value: "Tourist Bus",
                                  // label: "Tourist Bus",
                                  label:
                                    this.context.translate("_TOURIST_BUS_"),
                                  data: "25",
                                },
                                {
                                  value: "Boom Loader",
                                  // label: "Boom Loader",
                                  label:
                                    this.context.translate("_BOOM_LOADER_"),
                                  data: "26",
                                },
                                {
                                  value: "Generator",
                                  // label: "Generator",
                                  label: this.context.translate("_GENERATOR_"),
                                  data: "27",
                                },
                                {
                                  value: "Hilux",
                                  // label: "Hilux",
                                  label: this.context.translate("_HILUX_"),
                                  data: "28",
                                },
                                {
                                  value: "Motorcycle",
                                  // label: "Motorcycle",
                                  label: this.context.translate("_MOTORCYCLE_"),
                                  data: "29",
                                },
                                {
                                  value: "Taxi",

                                  label: this.context.translate("_TAXI_"),
                                  data: "30",
                                },
                                {
                                  value: "SmartPhone",
                                  // label: "Motorcycle",
                                  label:
                                    this.context.translate("_SMART_PHONE_"),
                                  data: "31",
                                },
                              ]}
                            />
                          </Form.Item>

                          {this.state.school && (
                            <>
                              <Form.Item
                                className="uploadCompany"
                                name="seater"
                                label={this.context.translate("_SERATER_")}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="mobileno"
                                // label="Attendant Mobile No"
                                label={this.context.translate(
                                  "_ATTENDANT_MOBILE_NO_"
                                )}
                                rules={[
                                  {
                                    pattern: /^(\d{7}|\d{10})$/,
                                    message: "Enter 7 or 10 Digit Number",
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validatePhoneNumber(
                                      e.target.value,
                                      "mobileno"
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="attendantName"
                                // label="Attendant Name"
                                label={this.context.translate(
                                  "_ATTENDANT_NAME_"
                                )}
                              >
                                <Input />
                              </Form.Item>
                            </>
                          )}

                          <Form.Item
                            className="uploadCompany"
                            name="timezoneId"
                            // label={this.context.translate(
                            //   "_FLEET_COMPANY_COMPANYDETAIL_TIME_"
                            // )}
                            label={
                              <span>
                                {this.context.translate(
                                  "_FLEET_COMPANY_COMPANYDETAIL_TIME_"
                                )}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_FLEET_COMPANY_COMPANYDETAIL_TIME_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                            initialValue={this.state.timezoneId}
                          >
                            <Select
                              showSearch
                              placeholder="Select TimeZone"
                              filterOption={(inputValue, option) => {
                                return (
                                  option.children
                                    .toLowerCase()
                                    .indexOf(inputValue.toLowerCase()) >= 0
                                );
                              }}
                              // defaultValue={"AMST - GMT+03:00"}
                            >
                              {this.countryStore?.timeZones.map((country) => {
                                return (
                                  <Option value={Number(country.timezoneId)}>
                                    {country.abbr}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="installDate"
                            // label={this.context.translate("_INSTALLATION_DATE_")}
                            label={
                              <span>
                                {this.context.translate("_INSTALLATION_DATE_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_INSTALLATION_DATE_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                                // message: "Please enter Installation Date",
                              },
                            ]}
                            initialValue={dayjs()}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format={dateFormat}
                              disabled={this.state.disabledField}
                            />
                          </Form.Item>
                          <Form.Item
                            className="uploadCompany"
                            name="paymentType"
                            // label={this.context.translate("_PAYMENT_TYPE_")}
                            label={
                              <span>
                                {this.context.translate("_PAYMENT_TYPE_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            initialValue={"Yearly"}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_PAYMENT_TYPE_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Select
                              disabled={this.state.disabledField}
                              options={[
                                {
                                  // label: "Monthly",
                                  label: this.context.translate("_MONTHLY_"),
                                  value: "Monthly",
                                },
                                // {
                                //   // label: "Quarterly",
                                //   label: this.context.translate("_QUARTERLY_"),
                                //   value: "Quarterly",
                                // },
                                // {
                                //   // label: "6 Months",
                                //   label: this.context.translate("_6_MONTHS_"),
                                //   value: "6Months",
                                // },
                                {
                                  // label: "Yearly",
                                  label: this.context.translate("_YEARLY_"),
                                  value: "Yearly",
                                },
                              ]}
                              onChange={(value) => {
                                if (value == "Monthly") {
                                  this.formRef.current.setFieldsValue({
                                    expiryDate: dayjs().add(1, "month"),
                                  });
                                  // } else if (value == "Quarterly") {
                                  //   this.formRef.current.setFieldsValue({
                                  //     expiryDate: dayjs().add(4, "month"),
                                  //   });
                                  // } else if (value == "6Months") {
                                  //   this.formRef.current.setFieldsValue({
                                  //     expiryDate: dayjs().add(6, "month"),
                                  //   });
                                } else if (value == "Yearly") {
                                  this.formRef.current.setFieldsValue({
                                    expiryDate: dayjs().add(1, "year"),
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                          <Form.Item
                            name="expiryDate"
                            className="uploadCompany"
                            label={this.context.translate(
                              "_VEHICLE_EXPIRY_DATE_"
                            )}
                            rules={[{ type: Date }]}
                            initialValue={dayjs().add(1, "years")}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format="YYYY-MM-DD"
                              disabled={this.state.disabledField}
                            />
                          </Form.Item>

                          <Form.Item
                            name="renewedAt"
                            className="uploadCompany"
                            label={this.context.translate("_RENEWED_AT_")}
                          >
                            <Input disabled />
                          </Form.Item>
                        </Col>

                        <Col span={12} className="formColumnClass">
                          <Form.Item
                            className="uploadCompany"
                            name="mulkiyaRenewal"
                            // label="Istimara Renewal Date"
                            label={this.context.translate(
                              "_MULKIYA_RENEWAL_DATE_1"
                            )}
                            rules={[{ type: Date }]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format={dateFormat}
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="insuranceRenewal"
                            // label="Insurance Expiry Date"
                            label={this.context.translate(
                              "_INSURANCE_EXPIRY_DATE_"
                            )}
                            rules={[{ type: Date }]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format={dateFormat}
                            />
                          </Form.Item>
                          <Form.Item
                            className="uploadCompany"
                            label={
                              <span>
                                {this.context.translate("_DRIVER_NAME_")}{" "}
                              </span>
                            }
                          >
                            <Space.Compact
                              style={{
                                width: "100%",
                                gap: "10px",
                              }}
                            >
                              <Form.Item
                                name="driverId"
                                className="uploadCompany"
                                label={this.context.translate("_DRIVER_NAME_")}
                                noStyle
                              >
                                <Select
                                  showSearch
                                  placeholder={this.context.translate(
                                    "_SELECT_DRIVER_"
                                  )}
                                  // onChange={(e) => this.setFieldsValues(e)}
                                  filterOption={(inputValue, option) => {
                                    return (
                                      option.children
                                        .toLowerCase()
                                        .indexOf(inputValue.toLowerCase()) >= 0
                                    );
                                  }}
                                  value={this.state.driverId}
                                  onSelect={this.selectDriver}
                                >
                                  {this.driverStore?.getDriverName?.map(
                                    (driver) => {
                                      return (
                                        <Option
                                          value={parseInt(driver.driverId)}
                                        >
                                          {driver.name}
                                        </Option>
                                      );
                                    }
                                  )}
                                </Select>
                              </Form.Item>
                              <Form.Item noStyle>
                                <Button
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "35px",
                                    backgroundColor: "#2196F3",
                                    padding: "0px 13px",
                                  }}
                                  onClick={() => {
                                    this.setState({
                                      openDriverDetailsForm: true,
                                    });
                                  }}
                                >
                                  <Image
                                    style={{ width: "13px", height: "13px" }}
                                    src={addIcon}
                                  ></Image>
                                </Button>
                              </Form.Item>
                            </Space.Compact>
                          </Form.Item>
                          {this.props.getUserData().isadmin !== 1 && (
                            <>
                              <Form.Item
                                className="uploadCompany"
                                name="full_imei"
                                // label={this.context.translate("_IMEI_")}
                                label={
                                  <span>
                                    {this.context.translate("_IMEI_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_IMEI_"
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_"
                                    )}`,
                                  },
                                ]}
                                help={
                                  this.state.imeiError
                                    ? this.state.imeiError
                                    : null
                                }
                                // validateStatus={this.state.imeiError ? "error" :''}
                                // status={this.state.imeiError ? "error" : false}
                              >
                                <Input
                                  status={this.state.imeiError ? "error" : null}
                                  onChange={(e) => {
                                    const value = e.target.value;

                                    if (this.state.imeiError) {
                                      this.setState({ imeiError: null });
                                    }

                                    this.validateYearField(value, "full_imei");
                                  }}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="vehiclesimno"
                                // label={this.context.translate("_SIM_NO_")}
                                label={
                                  <span>
                                    {this.context.translate("_SIM_NO_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_SIM_NO_"
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_"
                                    )}`,
                                  },
                                ]}
                              >
                                <Input
                                  onChange={(e) =>
                                    this.validateYearField(
                                      e.target.value,
                                      "vehiclesimno"
                                    )
                                  }
                                />
                              </Form.Item>
                            </>
                          )}
                          <Form.Item
                            name="speedlimit"
                            className="uploadCompany"
                            // label="Speed Limit"
                            // label={this.context.translate("_SPEED_LIMIT_")}
                            label={
                              <span>
                                {this.context.translate("_SPEED_LIMIT_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            initialValue={100}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_SPEED_LIMIT_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "speedlimit"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            name="idleLimit"
                            className="uploadCompany"
                            // label="Idle Limit"
                            // label={this.context.translate("_MAX_IDLE_LIMIT_")}
                            label={
                              <span>
                                {this.context.translate("_MAX_IDLE_LIMIT_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            initialValue={20}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_MAX_IDLE_LIMIT_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "idleLimit"
                                )
                              }
                            />
                          </Form.Item>

                          <VehicleAccountTabFormFields />

                          <Form.Item
                            className="uploadCompany"
                            name="vehicleBrand"
                            label={this.context.translate("_BRAND_")}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="vehicleModel"
                            label={this.context.translate("_VEHICLE_MODEL_")}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="ColorCode"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_COLOR_"
                            )}
                            initialValue={"FFFFFF"}
                          >
                            <ColorPicker
                              style={{ width: "100%", height: "40px" }}
                              format={formatHex}
                              color={colorHex}
                              onChange={this.handleChangeHex}
                              onFormatChange={this.handleFormatChangeHex}
                            />
                          </Form.Item>

                          {(this.props.getUserData().isadmin == -1 ||
                            this.props.getUserData().isadmin == 3) && (
                            <Form.Item
                              name="deviceId"
                              label={this.context.translate("_DEVICE_")}
                            >
                              <Select
                                options={[
                                  { label: "Ruptela", value: 1 },
                                  { label: "GT06 ", value: 5 },
                                  { label: "MDVR", value: 6 },
                                  { label: "GV300", value: 7 },
                                  { label: "PCBA", value: 8 },
                                  { label: "Atelematics", value: 9 },
                                  { label: "Teltonika", value: 10 },
                                  { label: "Meitrack", value: 11 },
                                  { label: "AK11", value: 12 },
                                  { label: "Howen MDVR", value: 13 },
                                  { label: "BCE", value: 14 },
                                  { label: "Wanway", value: 15 },
                                  { label: "Rutela Trace5", value: 16 },
                                  { label: "FMC 920", value: 17 },
                                  { label: "BSJ", value: 18 },
                                  { label: "Iridium", value: 22 },
                                ]}
                                onSelect={(val) => this.handleDeviceFields(val)}
                              />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>

                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.closeModal();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          // htmlType="submit"
                          // loading={this.state.loading}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div>
                    </TabPane>

                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["2"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "2"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_MAINTENANCE_DETAILS_")}
                          </Button>
                        </span>
                      }
                      key="2"
                      // style={{ marginLeft: "30px" }}
                    >
                      <Row
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <Col span={12} className="formColumnClass">
                          <>
                            <Form.Item
                              className="uploadCompany"
                              name="odometerReading"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_ODOMETER_"
                              )}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "odometerReading"
                                  )
                                }
                              />
                            </Form.Item>
                            {this.props.getUserData().isadmin == 0 ||
                              this.props.getUserData().isadmin == 1 ||
                              (!this.props.vehicleIdForEdit && (
                                <Form.Item
                                  className="uploadCompany"
                                  name="diffOdo"
                                  label={this.context.translate(
                                    "_DIFF_ODOMETER_"
                                  )}
                                >
                                  <Input
                                    onChange={(e) =>
                                      this.validateFieldsValue(
                                        e.target.value,
                                        "diffOdo"
                                      )
                                    }
                                  />
                                </Form.Item>
                              ))}

                            <Form.Item
                              className="uploadCompany"
                              name="lastservicedone"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_LASTSERVICE_"
                              )}
                              rules={[{ type: Date }]}
                            >
                              <DatePicker
                                style={{ width: "100%", height: "40px" }}
                                format={dateFormat}
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="lastoilchange"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_LASTOILCHANGE_"
                              )}
                              rules={[{ type: Date }]}
                            >
                              <DatePicker
                                style={{ width: "100%", height: "40px" }}
                                format={dateFormat}
                              />
                            </Form.Item>
                            <Form.Item
                              className="uploadCompany"
                              name="lasttirechange"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_LASTTIRE_"
                              )}
                              rules={[{ type: Date }]}
                            >
                              <DatePicker
                                style={{ width: "100%", height: "40px" }}
                                format={dateFormat}
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="lastBatteryDate"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_LASTBATTERY_"
                              )}
                              rules={[{ type: Date }]}
                            >
                              <DatePicker
                                style={{ width: "100%", height: "40px" }}
                                format={dateFormat}
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="batteryExpire"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_BATTERY_CHANGE_INT_"
                              )}
                              // label={"Battery Change Interval(Days)"}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "batteryExpire"
                                  )
                                }
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="tirechangeKm"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_TIRECHANGE_"
                              )}
                            >
                              <Input
                                placeholder={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_TIRECHANGE_"
                                )}
                                // placeholder="Tire C.(Km)"
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "tirechangeKm"
                                  )
                                }
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="oilchangeKm"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_OILCHANGE_"
                              )}
                            >
                              <Input
                                placeholder={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_OILCHANGE_"
                                )}
                                // placeholder="Oil C.(Km)"
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "oilchangeKm"
                                  )
                                }
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="serviceexpireKm"
                              label={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_SERVICEEXPIRE_"
                              )}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "serviceexpireKm"
                                  )
                                }
                              />
                            </Form.Item>

                            <Form.Item
                              className="uploadCompany"
                              name="machineservicehours"
                              label={this.context.translate(
                                "_MACHINE_SERVICE_HOURS_"
                              )}
                            >
                              <Input
                                onChange={(e) =>
                                  this.validateFieldsValue(
                                    e.target.value,
                                    "machineservicehours"
                                  )
                                }
                              />
                            </Form.Item>
                          </>
                          {/* )} */}
                          <Form.Item
                            className="uploadCompany"
                            name="vehiclePurchaseDate"
                            label={this.context.translate(
                              "_VEHICLE_PURCHASE_DATE_"
                            )}
                            rules={[{ type: Date }]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format={dateFormat}
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="totalVehicleCost"
                            label={this.context.translate(
                              "_TOTAL_VEHICLE_COST_"
                            )}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "totalVehicleCost"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="downPayment"
                            label={this.context.translate("_DOWN_PAYMENT_")}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="monthlyEmi"
                            label={this.context.translate("_MONTHLY_EMI_")}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "monthlyEmi"
                                )
                              }
                            />
                          </Form.Item>
                          <Form.Item
                            className="uploadCompany"
                            name="noOfEmi"
                            label={this.context.translate("_NO_OF_EMI_")}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "noOfEmi"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="emiDueDate"
                            label={this.context.translate("_EMI_DUE_DATE_")}
                            rules={[{ type: Date }]}
                          >
                            <DatePicker
                              style={{ width: "100%", height: "40px" }}
                              format={dateFormat}
                            />
                          </Form.Item>

                          {this.state.pulseFields && (
                            <>
                              {" "}
                              <Form.Item
                                className="uploadCompany"
                                name="speedConstant"
                                // label={this.context.translate("_SPEED_CONSTANT_")}
                                label={
                                  <span>
                                    {this.context.translate("_SPEED_CONSTANT_")}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_SPEED_CONSTANT_"
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_"
                                    )}`,
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                              <Form.Item
                                className="uploadCompany"
                                name="pulseCount"
                                // label={this.context.translate(
                                //   "_PULSE_COUNT_PER_CIRCLE_"
                                // )}
                                label={
                                  <span>
                                    {this.context.translate(
                                      "_PULSE_COUNT_PER_CIRCLE_"
                                    )}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_PULSE_COUNT_PER_CIRCLE_"
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_"
                                    )}`,
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>
                              <Form.Item
                                className="uploadCompany"
                                name="mileage"
                                // label={this.context.translate(
                                //   "_MILEAGE_PER_CIRCLE_"
                                // )}
                                label={
                                  <span>
                                    {this.context.translate(
                                      "_MILEAGE_PER_CIRCLE_"
                                    )}{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                }
                                required={false}
                                rules={[
                                  {
                                    required: true,
                                    message: `${this.context.translate(
                                      "_MILEAGE_PER_CIRCLE_"
                                    )} ${this.context.translate(
                                      "_IS_REQUIRED_"
                                    )}`,
                                  },
                                ]}
                              >
                                <Input />
                              </Form.Item>{" "}
                            </>
                          )}
                        </Col>
                        <Col span={12} className="formColumnClass">
                          <Form.Item
                            className="uploadCompany"
                            name="manufactureYear"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_MANUFACTURE_"
                            )}
                          >
                            <Input
                              className="uploadCompany"
                              // placeholder="Year"
                              placeholder={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_MANUFACTURE_"
                              )}
                              onChange={(e) =>
                                this.validateYearField(
                                  e.target.value,
                                  "manufactureYear"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="capacity"
                            //  label="Fuel Capacity"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_FUELCAPACITY_"
                            )}
                          >
                            <Input
                              placeholder={this.context.translate(
                                "_FLEET_VEHICLE_VEHICLEDETAIL_FUELCAPACITY_"
                              )}
                              // placeholder="Capacity"
                              // label="Capacity"
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "capacity"
                                )
                              }
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="fuelConsumption"
                            label={this.context.translate("_VEHICLE_MILAGE_")}
                          >
                            <Input />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="fuel"
                            //  label="Fuel Type:"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_FUELTYPE_"
                            )}
                          >
                            <Select>
                              <Select.Option value="Petrol">
                                {this.context.translate(
                                  "_FLEET_VEHICLEDETAIL_FUELTYPEDDL_PETROL"
                                )}
                              </Select.Option>
                              <Select.Option value="Diesel">
                                {this.context.translate(
                                  "_FLEET_VEHICLEDETAIL_FUELTYPE_DIESEL_"
                                )}
                              </Select.Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="fuelCalibrationId"
                            //  label="Fuel Type:"
                            label={this.context.translate("_FUEL_CALIBRATION_")}
                          >
                            <Select
                              options={this.vehicleStore?.fuelDetails}
                              fieldNames={{
                                label: "fuelCalibrationName",
                                value: "Id",
                              }}
                            />
                          </Form.Item>

                          {this.props.getUserData().isadmin !== 1 && (
                            <>
                              <Form.Item
                                className="uploadCompany"
                                name="DigInpt1"
                                // label=" DigiInput1:"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL1_"
                                )}
                              >
                                <Select
                                  options={[
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_DOOR_"
                                      ),
                                      value: "Door",
                                    },
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_SEATBELT_"
                                      ),
                                      value: "Seatbelt",
                                    },
                                    {
                                      // label: "ACC",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_ACC_"
                                      ),
                                      value: "ACC",
                                    },
                                    {
                                      // label: "Panic",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_PANIC_"
                                      ),
                                      value: "Panic",
                                    },
                                    {
                                      // label: "AC ",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_AC_"
                                      ),
                                      value: "AC",
                                    },
                                    {
                                      // label: "Passenger Seat Belt",
                                      label:
                                        this.context.translate(
                                          "_SEAT_SENSORS_"
                                        ),
                                      value: "Seatsensor",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="DigInpt2"
                                // label=" DigiInput2:"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL2_"
                                )}
                              >
                                <Select
                                  options={[
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_DOOR_"
                                      ),
                                      value: "Door",
                                    },
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_SEATBELT_"
                                      ),
                                      value: "Seatbelt",
                                    },
                                    {
                                      // label: "ACC",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_ACC_"
                                      ),
                                      value: "ACC",
                                    },
                                    {
                                      // label: "Panic",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_PANIC_"
                                      ),
                                      value: "Panic",
                                    },
                                    {
                                      // label: "AC ",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_AC_"
                                      ),
                                      value: "AC",
                                    },
                                    {
                                      // label: "Passenger Seat Belt",
                                      label:
                                        this.context.translate(
                                          "_SEAT_SENSORS_"
                                        ),
                                      value: "Seatsensor",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="DigInpt3"
                                // label=" DigiInput2:"
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_DIGITAL3_"
                                )}
                              >
                                <Select
                                  options={[
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_DOOR_"
                                      ),
                                      value: "Door",
                                    },
                                    {
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_SEATBELT_"
                                      ),
                                      value: "Seatbelt",
                                    },
                                    {
                                      // label: "ACC",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_ACC_"
                                      ),
                                      value: "ACC",
                                    },
                                    {
                                      // label: "Panic",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_PANIC_"
                                      ),
                                      value: "Panic",
                                    },
                                    {
                                      // label: "AC ",
                                      label: this.context.translate(
                                        "_FLEET_DASHBORD_SETTING_AC_"
                                      ),
                                      value: "AC",
                                    },
                                    {
                                      // label: "Passenger Seat Belt",
                                      label:
                                        this.context.translate(
                                          "_SEAT_SENSORS_"
                                        ),
                                      value: "Seatsensor",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </>
                          )}

                          <VehicleDetailsTabFormFields
                            isadmin={this.props.getUserData()}
                            vehicleIdForEdit={this.props.vehicleIdForEdit}
                            selectRules={this.state.selectRules}
                            handleSelectAllRules={this.handleSelectAllRules}
                            showPulseFields={this.showPulseFields}
                          />

                          <Form.Item
                            className="formCheckboxCss"
                            name="icon"
                            label=" "
                            // label={this.context.translate("_FLEET_DASHBORD_NEWPOI_PHOTO_")}
                            //  valuePropName="fileList"
                            style={{ marginTop: "14px" }}
                            getValueFromEvent={this.normFile}
                          >
                            <Upload
                              style={{ backgroundColor: "black" }}
                              name="icon"
                              action={
                                // config.baseURL + "/index.php?c=company&a=fileupload"
                                config.baseURL + this.vehicleStore.fileUploadUrl
                              }
                              listType="picture"
                              data={{
                                fileType: "vehicleicon",
                                fieldName: "icon",
                              }}
                              onChange={this.getUploadData}
                              onRemove={async () => {
                                await this.setState({
                                  photo: "",
                                  fileList: [],
                                });
                                await this.vehicleStore.setLogoFromDb([]);
                              }}
                              maxCount={1}
                              // fileList={this.companyStore.logoFromDb}
                              // onRemove={this.removeImage}
                              {...this.vehicleStore.logoFromDb}
                            >
                              <Button
                                className="imgupload"
                                icon={<UploadOutlined />}
                              >
                                {/* Click to upload */}
                                {this.context.translate("_CLICK_TO_UPLOAD_")}
                              </Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </Row>

                      {/* <div className="formBtnGroup">
                        <Button
                          className="formCancelButton"
                          onClick={this.handleBackClick}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          type="primary"
                          // htmlType=""
                          className="formSaveButton"
                          onClick={this.handleNextClick}
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div> */}
                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          // htmlType="submit"
                          // loading={this.state.loading}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div>
                    </TabPane>

                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["3"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "3"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {this.context.translate("_PERIPHERALS_")}
                          </Button>
                        </span>
                      }
                      key="3"
                      // style={{ marginLeft: "30px" }}
                    >
                      <Row
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <VehicleInfoAwtlFormFields
                          This={this.state}
                          isadmin={this.props.getUserData()}
                          installationType={this.installationType}
                          getTypeByCategory={this.getTypeByCategory}
                          validateFieldsValue={this.validateFieldsValue}
                          getWeightsUsingTid={this.getWeightsUsingTid}
                          formRef={this.formRef}
                          handleCheckboxChange={this.handleCheckboxValues}
                          warning={this.warning}
                          handleLoadSensorCheckbox={
                            this.handleLoadSensorCheckbox
                          }
                        />
                        <VehicleInfoTabFormFields
                          isadmin={this.props.getUserData()}
                          This={this.state}
                          handleCheckboxChange={this.handleCheckboxChange}
                          validateFieldsValue={this.validateFieldsValue}
                        />

                        <VehicleInfoDrive7Fields
                          isadmin={this.props.getUserData()}
                          This={this.state}
                          handleCheckboxChange={this.handleCheckboxChange}
                        />
                        {/* {this.state.mdvrFields && (
                        <>
                          <Row>
                            <Col>
                              <Form.Item
                                name="cmsvssWebHost"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="CMS/VSS Web Host"
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="MDVR"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="MDVR Server"
                              >
                                <Select
                                  placeholder="Select Type"
                                  options={[
                                    {
                                      label: "CMS",
                                      value: "CMS",
                                    },
                                    {
                                      label: "VSS",
                                      value: "VSS",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              <Form.Item
                                name="cmsvssWebPort"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="CMS/VSS Web Port"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                name="cmsvssLoginServerPort"
                                label="CMS/VSS Login Server Port"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="cmsvssPlaybachPort"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="CCMS/VSS Login Playback Port"
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="cmsvssUserName"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="CMS/VSS Username"
                              >
                                <Input />
                              </Form.Item>

                              <Form.Item
                                name="cmsvssPassword"
                                // label={storeContext.translate("_MDVR_IMEI_")}
                                label="CMS/VSS Password"
                              >
                                <Input />
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )} */}
                      </Row>

                      {/* <div className="formBtnGroup">
                        <Button
                          className="formCancelButton"
                          onClick={this.handleBackClick}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          type="primary"
                          className="formSaveButton"
                          onClick={this.handleNextClick}
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div> */}
                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          // htmlType="submit"
                          // loading={this.state.loading}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_NEXT_")}
                        </Button>
                      </div>
                    </TabPane>

                    <TabPane
                      tab={
                        <span
                          className={
                            this.state.tabErrors["4"] && "validation-failed"
                          }
                        >
                          <Button
                            type="text"
                            style={{
                              background:
                                this.state.activeTab === "4"
                                  ? " rgba(255, 255, 255, 0.30)"
                                  : "rgb(7, 22, 61)",
                              border: "none",
                              borderRadius: "0px",
                            }}
                          >
                            {/* Tank Details */}
                            {this.context.translate("_TANK_DETAILS_")}
                          </Button>
                        </span>
                      }
                      key="4"
                      // style={{ marginLeft: "30px" }}
                    >
                      <Row
                        style={{
                          overflowY: "scroll",
                          height: "90%",
                          paddingInlineStart: "20px",
                        }}
                      >
                        <Col span={12} className="formColumnClass">
                          <Form.Item
                            className="uploadCompany"
                            name="nofueltank"
                            // label="Number of Fuel Tanks"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_FUELTANK_"
                            )}
                            initialValue={3}
                          >
                            <Select
                              onChange={(value) => {
                                this.noOfFuelTanks(value);
                              }}
                              options={[
                                { label: "1", value: 1 },
                                { label: "2", value: 2 },
                                { label: "3", value: 3 },
                              ]}
                            />
                          </Form.Item>

                          <Form.Item
                            className="uploadCompany"
                            name="tankvolume"
                            //  label=" Tank Volume"
                            label={this.context.translate(
                              "_FLEET_VEHICLE_VEHICLEDETAIL_TANKVOLUME_"
                            )}
                          >
                            <Input
                              onChange={(e) =>
                                this.validateFieldsValue(
                                  e.target.value,
                                  "tankvolume"
                                )
                              }
                            />
                          </Form.Item>

                          <VehicleTankTabFormFields />
                          {this.state.one && (
                            <>
                              <Form.Item
                                className="uploadCompany"
                                name="tankshape1"
                                label={
                                  <label
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {/* Tank 1 Shape */}
                                    {this.context.translate(
                                      "_FLEET_VEHICLE_VEHICLEDETAIL_TANK1SHAPE_"
                                    )}
                                  </label>
                                }
                              >
                                <Select
                                  // placeholder="Select Tank Shape"
                                  placeholder={this.context.translate(
                                    "_SELECT_TANK_SHAPE_"
                                  )}
                                  onChange={(value) => {
                                    this.tankShape1(value);
                                  }}
                                  options={[
                                    {
                                      // label: "Horizontal Rectangle",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_HORIZONTAL_"
                                      ),
                                      value: "Horizontal Rectangle",
                                    },
                                    {
                                      // label: "Vertical Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_VERTICAL_"
                                      ),
                                      value: "Vertical Cylinder",
                                    },
                                    {
                                      // label: "Horizontal Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_CYLINDRICAL_"
                                      ),
                                      value: "Horizontal Cylinder",
                                    },
                                  ]}
                                />
                              </Form.Item>
                              {this.state.horizontalrectangle && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginRight: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank (L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK_L_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={11}>
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankwidth1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank (W) in Cm. */}
                                            {this.context.translate(
                                              "_TANK_W_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_WIDTH_"
                                          )}
                                          // placeholder="Width"
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankwidth1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>

                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankheight1"
                                    label={
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* Tank (Height) in Cm. */}
                                        {this.context.translate(
                                          "_TANK_HEIGHT_IN_CM_"
                                        )}
                                      </label>
                                    }
                                    // label={" "}
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_HEIGHT__"
                                      )}
                                      // placeholder="Height"
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankheight1"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              {this.state.verticalcylinder && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginRight: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank1(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK1_l_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginLeft: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank1(D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK1_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              {this.state.horizontalcylinder && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginRight: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank1(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK1_l_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginLeft: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter1"
                                        label={
                                          <label
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank1(D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK1_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter1"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              <Form.Item
                                className="uploadCompany"
                                name="fid1"
                                // label="F Id 1"
                                // label={<label style={{ color: "red" }}>F Id 1</label>}
                                label={this.context.translate(
                                  "_FLEET_VEHICLE_VEHICLEDETAIL_FID1_"
                                )}
                                // label={
                                //   <label style={{ color: "red" }}>F Id 1</label>
                                // }
                              >
                                <Input
                                  placeholder="F Id 1"
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "fid1"
                                    )
                                  }
                                />
                              </Form.Item>

                              <Form.Item
                                className="uploadCompany"
                                name="installationspace1"
                                // label="Installation Space1(Cm)"
                                label={
                                  <label
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {/* Installation Space1(Cm) */}
                                    {this.context.translate(
                                      "_FLEET_VEHICLE_VEHICLEDETAIL_INSTALLATIONSPACE1_"
                                    )}
                                  </label>
                                }
                              >
                                <Input
                                  // placeholder="Space 1(Cm)"
                                  placeholder={this.context.translate(
                                    "_SPACE_1_CM_"
                                  )}
                                  onChange={(e) =>
                                    this.validateFieldsValue(
                                      e.target.value,
                                      "installationspace1"
                                    )
                                  }
                                />
                              </Form.Item>
                            </>
                          )}
                        </Col>
                        <Col span={12} className="formColumnClass">
                          {this.state.two && (
                            <>
                              {/* #00e600 */}

                              <Form.Item
                                className="uploadCompany"
                                name="tankshape2"
                                label={
                                  <label
                                    style={{ color: "green", fontSize: "12px" }}
                                  >
                                    {/* Tank 2 Shape */}
                                    {this.context.translate(
                                      "_FLEET_VEHICLE_VEHICLEDETAIL_TANK2SHAPE_"
                                    )}
                                  </label>
                                }
                              >
                                <Select
                                  // placeholder="Select Tank2 Shape"
                                  placeholder={this.context.translate(
                                    "_SELECT_TANK2_SHAPE_"
                                  )}
                                  onChange={(value) => {
                                    this.tankShape2(value);
                                  }}
                                  options={[
                                    {
                                      // label: "Horizontal Rectangle",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_HORIZONTAL_"
                                      ),
                                      value: "Horizontal Rectangle",
                                    },
                                    {
                                      // label: "Vertical Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_VERTICAL_"
                                      ),
                                      value: "Vertical Cylinder",
                                    },
                                    {
                                      // label: "Horizontal Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_CYLINDRICAL_"
                                      ),
                                      value: "Horizontal Cylinder",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              {this.state.horizontalrectangle2 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank2(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_L_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          // style={{marginTop:"10px"}}
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankwidth2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank2(W) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_W_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_WIDTH_"
                                          )}
                                          // placeholder="Width"
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankwidth2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Form.Item
                                    // className="uploadCompany"
                                    name="tankheight2"
                                    label={
                                      <label
                                        style={{
                                          color: "green",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* Tank2(H) in Cm. */}
                                        {this.context.translate(
                                          "_TANK2_H_IN_CM_"
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      // placeholder="Height"
                                      placeholder={this.context.translate(
                                        "_HEIGHT__"
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankheight2"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              {this.state.verticalcylinder2 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank2(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_L_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank2(D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              {this.state.horizontalcylinder2 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank2(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_L_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter2"
                                        label={
                                          <label
                                            style={{
                                              color: "green",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank 2 (D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK2_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter2"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              <Row>
                                <Col span={11} style={{ marginTop: "-17px" }}>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="fid2"
                                    label={
                                      <label
                                        style={{
                                          color: "green",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* F Id 2 */}
                                        {this.context.translate("_F_ID_2_")}
                                      </label>
                                    }
                                  >
                                    <Input
                                      // placeholder="F Id 2"
                                      placeholder={this.context.translate(
                                        "_F_ID_2_"
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "fid2"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={2}></Col>
                                <Col span={11} style={{ marginTop: "-17px" }}>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="installationspace2"
                                    label={
                                      <label
                                        style={{
                                          color: "green",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* Space 2(Cm) */}
                                        {this.context.translate("_SPACE_2_CM_")}
                                      </label>
                                    }
                                  >
                                    <Input
                                      // placeholder=" Space 2(Cm)"
                                      placeholder={this.context.translate(
                                        "_SPACE_2_CM_"
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "installationspace2"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>

                              {/* <Form.Item
                          name="fid2"
                          label={
                            <label style={{ color: "green" }}>F Id 2</label>
                          }
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          name="installationspace2"
                          label={
                            <label style={{ color: "green" }}>
                              Installation Space 2(Cm)
                            </label>
                          }
                        >
                          <Input />
                        </Form.Item> */}
                            </>
                          )}

                          {this.state.three && (
                            <>
                              <Form.Item
                                className="uploadCompany"
                                name="tankshape3"
                                label={
                                  <label
                                    style={{
                                      color: "#FF33C7",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {/* Tank 3 Shape */}
                                    {this.context.translate(
                                      "_FLEET_VEHICLE_VEHICLEDETAIL_TANK3SHAPE_"
                                    )}
                                  </label>
                                }
                              >
                                <Select
                                  // placeholder="Select Tank 3 Shape"
                                  placeholder={this.context.translate(
                                    "_SELECT_TANK3_SHAPE_"
                                  )}
                                  onChange={(value) => {
                                    this.tankShape3(value);
                                  }}
                                  options={[
                                    {
                                      // label: "Horizontal Rectangle",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_HORIZONTAL_"
                                      ),
                                      value: "Horizontal Rectangle",
                                    },
                                    {
                                      // label: "Vertical Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_VERTICAL_"
                                      ),
                                      value: "Vertical Cylinder",
                                    },
                                    {
                                      // label: "Horizontal Cylinder",
                                      label: this.context.translate(
                                        "_FLEET_VEHICLE_VEHICLEDETAIL_TANKSHAPE_CYLINDRICAL_"
                                      ),
                                      value: "Horizontal Cylinder",
                                    },
                                  ]}
                                />
                              </Form.Item>

                              {this.state.horizontalrectangle3 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankwidth3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(W) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_W_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_WIDTH_"
                                          )}
                                          // placeholder="Width"
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankwidth3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="tankheight3"
                                    label={
                                      <label
                                        style={{
                                          color: "#FF33C7",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* Tank3(H) in Cm. */}
                                        {this.context.translate(
                                          "_TANK3_H_IN_CM_"
                                        )}
                                      </label>
                                    }
                                  >
                                    <Input
                                      placeholder={this.context.translate(
                                        "_HEIGHT__"
                                      )}
                                      // placeholder="Height"
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "tankheight3"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </>
                              )}

                              {this.state.verticalcylinder3 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              {this.state.horizontalcylinder3 && (
                                <>
                                  <Row>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tanklength3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(L) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          className="uploadCompany"
                                          placeholder={this.context.translate(
                                            "_LENGTH_"
                                          )}
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tanklength3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                    <Col span={2}></Col>
                                    <Col
                                      span={11}
                                      style={{ marginTop: "-17px" }}
                                    >
                                      <Form.Item
                                        className="uploadCompany"
                                        name="tankdiameter3"
                                        label={
                                          <label
                                            style={{
                                              color: "#FF33C7",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {/* Tank3(D) in Cm. */}
                                            {this.context.translate(
                                              "_TANK3_D_IN_CM_"
                                            )}
                                          </label>
                                        }
                                      >
                                        <Input
                                          placeholder={this.context.translate(
                                            "_DIAMETER_"
                                          )}
                                          // placeholder="Diameter"
                                          onChange={(e) =>
                                            this.validateFieldsValue(
                                              e.target.value,
                                              "tankdiameter3"
                                            )
                                          }
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </>
                              )}

                              <Row>
                                <Col span={11} style={{ marginTop: "-17px" }}>
                                  <Form.Item
                                    name="fid3"
                                    className="uploadCompany"
                                    label={
                                      <label
                                        style={{
                                          color: "#FF33C7",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* F Id 3 */}
                                        {this.context.translate("_F_ID_3_")}
                                      </label>
                                    }
                                  >
                                    <Input
                                      // placeholder="F Id 3"
                                      placeholder={this.context.translate(
                                        "_F_ID_3_"
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "fid3"
                                        )
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                                <Col span={2}></Col>
                                <Col span={11} style={{ marginTop: "-17px" }}>
                                  <Form.Item
                                    className="uploadCompany"
                                    name="installationspace3"
                                    label={
                                      <label
                                        style={{
                                          color: "#FF33C7",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {/* Space 3(Cm) */}
                                        {this.context.translate("_SPACE_3_CM_")}
                                      </label>
                                    }
                                  >
                                    <Input
                                      // placeholder=" Space 3(Cm)"
                                      placeholder={this.context.translate(
                                        "_SPACE_3_CM_"
                                      )}
                                      onChange={(e) =>
                                        this.validateFieldsValue(
                                          e.target.value,
                                          "installationspace3"
                                        )
                                      }
                                    />
                                  </Form.Item>

                                  {/* <Form.Item
                          name="fid3"
                          label={
                            <label style={{ color: "#FF33C7" }}>F Id 3</label>
                          }
                        >
                          <Input />
                        </Form.Item>

                        <Form.Item
                          name="installationspace3"
                          label={
                            <label style={{ color: "#FF33C7" }}>
                              Installation Space 3(Cm)
                            </label>
                          }
                        >
                          <Input />
                        </Form.Item> */}
                                </Col>
                              </Row>
                            </>
                          )}
                        </Col>
                      </Row>
                      {/* <div className="formbuttons" style={{ textAlign: "center" }}>
                    <Space>
                      <Button
                        className="backbtn"
                        onClick={this.handleBackClick}
                      >
                        Back
                      </Button>
                      <Button className="nextbtn" htmlType="submit">
                        Submit
                      </Button>
                    </Space>
                  </div> */}
                      {/* <div className="formBtnGroup">
                        <Button
                          className="formCancelButton"
                          onClick={this.handleBackClick}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          type="primary"
                          className="formSaveButton"
                          htmlType="submit"
                        >
                          {this.context.translate("_SUBMIT_")}
                        </Button>
                      </div> */}
                      <div className="formFooter">
                        <Button
                          className="formsCancelButton"
                          onClick={() => {
                            this.handleBackClick();
                          }}
                        >
                          {this.context.translate(
                            "_FLEET_USER_USERLIST_ASSIGNVEHICLE_BACKBTN_"
                          )}
                        </Button>
                        <Button
                          onClick={(e) => {
                            this.handleNextClick();
                          }}
                          htmlType="submit"
                          // loading={this.state.loading}
                          className="formsSaveButton"
                        >
                          {this.context.translate("_SUBMIT_")}
                        </Button>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </Form>
            </Spin>
          </div>

          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openDriverDetailsForm}
            placement={
              this.context.locale.language === "arabic" ? "left" : "right"
            }
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_DRIVER_DETAILS_")}
                <p className="formDescription">
                  {this.context.translate("_DRIVER_ADD_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openDriverDetailsForm: false })}
            onCancel={() => this.setState({ openDriverDetailsForm: false })}
          >
            <div style={{ height: "100%" }}>
              <DriverAdd
                response={this.responseMsg}
                closeModal={this.closeDriverModal}
              ></DriverAdd>
            </div>
          </Drawer>
        </div>
      </>
    );
  }
}

VehicleAdd.contextType = StoreContext;
export default observer(withRouter(VehicleAdd));
